<template>
  <div class="app-container">
    <div class="screen">
      <el-form
        label-width="200px"
        :inline="true"
        :model="screen"
        class="form-inline"
        label-position="left"
      >
        <el-form-item label="选择园区">
          <el-select
            filterable
            v-model="screen.park_id"
            placeholder="请选择园区"
            :disabled="userInfo.park_id != 0"
            @change="screenParkchange"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="定期模式">
          <el-select
            filterable
            v-model="screen.pattern"
            placeholder="请选择定期模式"
          >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in statusList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否跨天">
          <el-select
            filterable
            v-model="screen.is_cross_origin"
            placeholder="请选择是否跨天"
          >
            <el-option label="请选择" value="0"></el-option>
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检人类型">
          <el-select
            filterable
            v-model="screen.patrol_type"
            placeholder="请选择巡检人类型"
            @change="changePatrolType"
          >
            <el-option label="请选择" value="0"></el-option>
            <el-option label="角色" value="2"></el-option>
            <el-option label="人" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="screen.patrol_type == 1" label="巡检人">
            <el-select
              filterable
              v-model="screen.patrol_user_id"
              placeholder="请选择巡检人"
              @change="this.$forceUpdate()"
            >
              <el-option v-for="(item,index) in patrolUserList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item> 
          <el-form-item v-if="screen.patrol_type == 2" label="巡检角色">
            <el-select
              filterable
              v-model="screen.patrol_role_id"
              placeholder="请选择巡检角色"
              @change="this.$forceUpdate()"
            >
            <el-option v-for="(item,index) in patrolRoleList" :key="index" :label="item.title" :value="item.id"></el-option>
            </el-select>
          </el-form-item> 
        <el-form-item label="是否跳过周末">
          <el-select
            filterable
            v-model="screen.is_skip_weekends"
            placeholder="请选择是否跳过周末"
          >
            <el-option label="请选择" value="0"></el-option>
            <el-option label="不跳过" value="2"></el-option>
            <el-option label="跳过" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否为共享任务">
          <el-select
            filterable
            v-model="screen.is_share"
            placeholder="请选择是否为共享任务"
          >
            <el-option label="请选择" value=""></el-option>
            <el-option label="是" value="2"></el-option>
            <el-option label="否" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务开始创建时间">
          <el-date-picker
            v-model="screen.start_create_time"
            type="date"
            placeholder="任务开始创建时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="任务结束创建时间">
          <el-date-picker
            v-model="screen.end_create_time"
            type="date"
            placeholder="任务结束创建时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="名称/编号">
          <el-input
            v-model="screen.keywords"
            placeholder="设备名称/设备编号/设备编码/规格型号"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检点的名称">
          <el-input v-model="screen.name" placeholder="巡检点的名称"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select
            filterable
            v-model="screen.status"
            placeholder="请选择状态"
          >
            <el-option label="请选择" value="0"></el-option>
            <el-option label="禁用" value="2"></el-option>
            <el-option label="启用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索" class="searchs">
          <el-button type="primary" @click="(page = 1), fetchData()"
            >查询</el-button
          >
          <el-button type="primary" plain @click="chongZhi()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-button
      type="info"
      @click="disable()"
      style="margin-bottom: 5px"
      :disabled="multipleSelection.length == 0"
      v-if="roles.includes('/patrol/equipment_disable')"
      >批量停用</el-button
    >
    <el-button
      type="success"
      @click="enable()"
      style="margin-bottom: 5px"
      :disabled="multipleSelection.length == 0"
      v-if="roles.includes('/patrol/equipment_enable')"
      >批量启用</el-button
    >
    <el-button
      type="primary"
      @click="addMenu()"
      style="margin-bottom: 5px"
      v-if="roles.includes('/patrol/equipment_add')"
      >添加任务</el-button
    >

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column  type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (page - 1) * page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属项目" align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.park ? scope.row.park.name : "" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="任务名称" align="center">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column label="有效时间" align="center" width="200">
        <template slot-scope="scope">
          {{ scope.row.start_date }} 至 {{ scope.row.end_date }}
        </template>
      </el-table-column>
      <el-table-column label="定期模式" align="center" min-width="180">
        <template slot-scope="scope">
          <span v-if="scope.row.pattern == 1">天</span>
          <span v-if="scope.row.pattern == 2">周</span>
          <span v-if="scope.row.pattern == 3">月</span>
          <span v-if="scope.row.pattern == 4">季</span>
          <span v-if="scope.row.pattern == 5">年</span>
        </template>
      </el-table-column>
      <el-table-column label="任务时间" align="center" width="150">
        <template slot-scope="scope">
          <!-- {{ scope.row.patrol_pattern_json }} -->
          <div
            :key="index"
            v-for="(item, index) in scope.row.patrol_pattern_json"
          >
            {{ item.start_time }}-{{ item.end_time }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="巡检人/角色" align="center" width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.patrol_user.length > 0">
            <div :key="index" v-for="(item, index) in scope.row.patrol_user">
              <span v-if="index != 0">，</span> {{ item.user.name }}
            </div>
          </template>
          <template v-if="scope.row.patrol_role.length > 0">
            <div :key="index" v-for="(item, index) in scope.row.patrol_role">
              <span v-if="index != 0">，</span> {{ item.system_role.title }}
            </div>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="持续天数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.duration_day }}</span>
        </template>
      </el-table-column>
      <el-table-column label="任务状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="created_at"
        label="操作"
        width="220"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            style="margin-top: 10px"
            size="mini"
            type="info"
            @click="disable(scope.row.id, 'single')"
            v-if="
              roles.includes('/patrol/equipment_disable') &&
              scope.row.status == 1
            "
            >停用</el-button
          >
          <el-button
            style="margin-top: 10px"
            size="mini"
            type="success"
            @click="enable(scope.row.id, 'single')"
            v-if="
              roles.includes('/patrol/equipment_enable') &&
              scope.row.status == 2
            "
            >启用</el-button
          >
          <el-button
            style="margin-top: 10px"
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/patrol/equipment_info')"
            >查看</el-button
          >
          <el-button
            style="margin-top: 10px"
            size="mini"
            type="primary"
            @click="handleCopy(scope.row)"
            v-if="roles.includes('/patrol/equipment_info')"
            >复制</el-button
          >
          <el-button
            style="margin-top: 10px"
            size="mini"
            type="danger"
            @click="delEq(scope.row.id)"
            v-if="roles.includes('/patrol/equipment_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[15, 30, 50]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
      @opened="openDrawer"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        label-position="top"
      >
        <el-form-item label="所属项目" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="cztype != 'add' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务名称" prop="name">
          <el-input
            class="w4"
            v-model="ruleForm.name"
            placeholder="请输入任务名称"
            :disabled="cztype == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务有效时间" required>
          <el-date-picker
            v-model="timeData"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :disabled="cztype == 'see'"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="cztype == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="是否需要扫码巡检" prop="is_scan">
          <el-radio-group v-model="ruleForm.is_scan" :disabled="cztype == 'see'">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="定期模式" prop="pattern">
          <el-radio-group
            v-model="ruleForm.pattern"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">天</el-radio>
            <el-radio :label="2">周</el-radio>
            <el-radio :label="3">月</el-radio>
            <el-radio :label="4">季</el-radio>
            <el-radio :label="5">年</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-if="ruleForm.pattern == 1">
          <div class="headbox">
            <span>每天：</span>
            <el-button v-if="cztype != 'see'" type="info" @click="addDomain()"
              >添加</el-button
            >
          </div>
          <el-table
            :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
            :data="timeList"
            style="width: 100%"
          >
            <el-table-column label="开始时间">
              <template slot-scope="scope">
                <el-time-picker
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  v-model="scope.row.start_time"
                  placeholder="开始时间"
                  :disabled="cztype == 'see'"
                >
                </el-time-picker>
              </template>
            </el-table-column>
            <el-table-column label="结束时间">
              <template slot-scope="scope">
                <el-time-picker
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  v-model="scope.row.end_time"
                  placeholder="结束时间"
                  :disabled="cztype == 'see'"
                >
                </el-time-picker>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="removeDomain(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="" v-if="ruleForm.pattern == 2">
          <el-checkbox-group v-model="checkList" :disabled="cztype == 'see'">
            <el-checkbox :label="1">周一</el-checkbox>
            <el-checkbox :label="2">周二</el-checkbox>
            <el-checkbox :label="3">周三</el-checkbox>
            <el-checkbox :label="4">周四</el-checkbox>
            <el-checkbox :label="5">周五</el-checkbox>
            <el-checkbox :label="6">周六</el-checkbox>
            <el-checkbox :label="7">周七</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          :label="ruleForm.pattern == 3 ? '每月的第几天' : '每季的第几天'"
          v-if="ruleForm.pattern == 3 || ruleForm.pattern == 4"
        >
          <el-input-number
            :disabled="cztype == 'see'"
            v-model="dayNum"
            :step="1"
          ></el-input-number>
          <!-- <el-input
            class="w4"
            v-model="dayNum"
            placeholder="请输入账号名称"
          ></el-input> -->
        </el-form-item>
        <el-form-item label="开始日期" v-if="ruleForm.pattern == 5">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="year_start_time"
            type="date"
            placeholder="选择日期"
            :disabled="cztype == 'see'"
          >
          </el-date-picker>
        </el-form-item>
        <div v-if="ruleForm.pattern != 1">
          <el-form-item label="开始时间">
            <el-time-picker
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.start_time"
              placeholder="任意时间点"
              :disabled="cztype == 'see'"
            >
            </el-time-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-time-picker
              format="HH:mm:ss"
              value-format="HH:mm:ss"
              v-model="timeStr.end_time"
              placeholder="任意时间点"
              :disabled="cztype == 'see'"
            >
            </el-time-picker>
          </el-form-item>
        </div>

        <el-form-item
          label="是否跳过周末"
          prop="is_skip_weekends"
          v-show="ruleForm.pattern != 2"
        >
          <el-radio-group
            v-model="ruleForm.is_skip_weekends"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="1">跳过</el-radio>
            <el-radio :label="2">不跳过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否跳过国定假期" prop="is_jump_holiday">
          <el-radio-group
            v-model="ruleForm.is_jump_holiday"
            :disabled="cztype == 'see'"
          >
            <el-radio :label="2">是</el-radio>
            <el-radio :label="1">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="持续时间" prop="duration_day">
          <el-input
            :disabled="cztype == 'see'"
            type="Number"
            class="w4 numInput"
            v-model="ruleForm.duration_day"
            placeholder="请输入持续时间"
            ><template slot="append">天</template></el-input
          >
        </el-form-item>
        <!-- 选择设施设备 -->
        <el-form-item label="选择设施设备">
          <el-button
            type="primary"
            @click="handleAdd()"
            style="margin-bottom: 5px"
            v-if="cztype != 'see'"
            >添加设施设备</el-button
          >
          <el-table
            :data="patrol_json"
            border
            :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
          >
            <template slot="empty">
              <el-button
                type="primary"
                @click="handleAdd"
                style="margin-bottom: 35px"
                >添加设施设备</el-button
              >
            </template>
            <el-table-column label="设施" align="center">
              <template slot-scope="scope">
                <el-select
                  filterable
                  @change="
                    (id) => {
                      changeFacility(id, scope.$index);
                    }
                  "
                  class="w4"
                  v-model="scope.row.facility_id"
                  placeholder="请选择设施"
                  :disabled="cztype == 'see'"
                >
                  <el-option
                    :disabled="
                      facilityIds.indexOf(item1.id) != -1 ? true : false
                    "
                    :label="item1.name"
                    :value="item1.id"
                    v-for="(item1, index1) in SSoptions"
                    :key="index1"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="设备" align="center">
              <template slot-scope="scope">
                <el-select
                  filterable
                  multiple
                  collapse-tags
                  v-model="scope.row.equipment_id"
                  placeholder="请选择设备"
                  :disabled="cztype == 'see'"
                >
                  <el-option
                    v-for="item in EmOptions[scope.$index]"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="cztype != 'see'"
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="handleDel(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item prop="is_share">
          <span slot="label">
            是否共享
            <el-tooltip
              content="开启后参与的巡检人可以共同完成该任务"
              effect="light"
              placement="top-start"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-radio-group
            v-model="ruleForm.is_share"
            :disabled="cztype == 'see'"
            @input="ChangeShare"
          >
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="巡检人类型" prop="patrol_type">
          <el-radio-group
            v-model="ruleForm.patrol_type"
            :disabled="cztype == 'see'"
            @change="patrolTypeChange"
          >
            <el-radio :label="1">人</el-radio>
            <el-radio :label="2">角色</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="指定巡检人"
          prop="patrol_user_id"
          v-if="ruleForm.patrol_type == 1"
        >
          <span slot="label"
            ><span style="color: #f00">* </span>指定巡检人</span
          >
          <el-select
            filterable
            v-model="ruleForm.patrol_user_id"
            placeholder="指定巡检人"
            :disabled="cztype == 'see'"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in userList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="指定巡检角色"
          prop="patrol_role_id"
          v-if="ruleForm.patrol_type == 2"
        >
          <span slot="label"
            ><span style="color: #f00">* </span>指定巡检角色</span
          >
          <el-select
            filterable
            v-model="ruleForm.patrol_role_id"
            placeholder="指定巡检角色"
            :disabled="cztype == 'see'"
            :multiple="ruleForm.is_share == 2"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="item in roleList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="cztype == 'add' || cztype == 'copy'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button v-if="cztype == 'see'" type="primary" @click="openEdit()">
            编辑
          </el-button>
          <el-button
            v-if="cztype == 'see'"
            type="primary"
            @click="drawer = false"
          >
            关闭
          </el-button>
          <el-button
            v-if="cztype == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button v-if="cztype != 'see'" type="info" @click="drawer = false">
            取消
          </el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  applyLists,
  infoAgo,
  openPark,
  openRole,
  openCompany,
  maintenanceType,
  getByUser,
  transfer,
  dispatch,
  reasonLists,
  openAgoUser,
  maintenanceLogLists,
} from "@/api/index";
import {
  addEquipmentPatrol,
  seeEquipmentPatrol,
  patrolEquipmentLists,
  getFacilityTypeList,
  getEquipmentList,
  delEquipmentPatrol,
  enableEquipmentPatrol,
  disableEquipmentPatrol,
  editEquipmentPatrol,
  copyEquipmentPatrol,
} from "@/api/facility";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl"]),
  },
  data() {
    return {
      patrol_json: [{ facility_id: "", equipment_id: "" }],
      // 任务有效时间
      timeData: [],
      // 周期列表
      checkList: [],
      // 时间列表
      timeList: [
        {
          start_time: "",
          end_time: "",
        },
      ],
      // 第几天
      dayNum: 1,
      // 年的时候开始日期
      year_start_time: "",
      timeStr: {
        start_time: "",
        end_time: "",
      },
      statusList: [
        {
          name: "请选择",
          value: "0",
        },
        {
          name: "天",
          value: "1",
        },
        {
          name: "周",
          value: "2",
        },
        {
          name: "月",
          value: "3",
        },
        {
          name: "季",
          value: "4",
        },
        {
          name: "年",
          value: "5",
        },
      ],
      token: getToken(),
      list: [],
      total: 0,
      page: 1,
      page_size: 15,
      screen: {
        park_id: "",
        status: "",
        name: "",
        pattern: "",
        is_cross_origin: "",
        start_create_time: "",
        end_create_time: "",
        patrol_type: "",
        is_skip_weekends: "",
        is_share: "",
        keywords: "",
        patrol_user_id:'',
        patrol_role_id:''
      },

      parkList: [],
      drawerTitle: "",
      cztype: "",
      drawer: false,
      ruleForm: {
        maintenance_transfer_reason_id: "",
        to_maintenance_type_id: "",
        source: 2,
        des: "",
        to_user_id: "",
        image: [],
        to_maintenance_type_son_id: "",
      },
      rules: {
        park_id: [
          {
            required: true,
            message: "请选择所属项目",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
          },
        ],
        pattern: [
          {
            required: true,
            message: "请选择定期模式",
          },
        ],
        duration_day: [
          {
            required: true,
            message: "请输入持续天数",
          },
        ],
        is_share: [
          {
            required: true,
            message: "请选择是否为共享任务",
          },
        ],
        is_skip_weekends: [
          {
            required: true,
            message: "请选择是否跳过周末",
          },
        ],
        patrol_type: [
          {
            required: true,
            message: "请选择巡检人类型",
          },
        ],
      },
      parkId: "",
      status: 0,
      SSoptions: [],
      facilityIds: [],
      EmOptions: [],
      roleList: [],
      userList: [],
      multipleSelection: [],
      patrolUserList:[],
      patrolRoleList:[]
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      this.screen.type = this.userInfo.type;
    } else {
      this.screen.park_id = "";
    }
    if (this.userInfo.company_id !== 0) {
      this.screen.company_id = this.userInfo.company_id;
    } else {
      this.screen.company_id = "";
    }
    this.getPark();
    this.fetchData();
  },
  methods: {
    changePatrolType(e){
      this.screen.patrol_user_id = null
      this.screen.patrol_role_id = null
      console.log(e)
      if(e == 1){
        let data  ={ park_id: this.screen.park_id, type: 1, is_page: 2,is_youke:2 }
        // 获取巡检人
        openAgoUser(data).then((res) => {
        this.patrolUserList = res.data.lists;
      });
      }else if(e == 2){
        // 获取巡检角色
        const data = {
        is_page: 2,
        is_tree: 1,
        park_id: this.screen.park_id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.patrolRoleList = res.data.lists;
      });
      }
    },
    selectable(row, index) {
      if(row.status == 2){
        return false
      }else{
        return true
      }
    },
    // 触发共享
    ChangeShare(e) {
      if (e == 2) {
        this.ruleForm.patrol_user_id = [];
        this.ruleForm.patrol_role_id = [];
      } else {
        this.ruleForm.patrol_user_id = "";
        this.ruleForm.patrol_role_id = "";
      }
    },
    // 编辑
    openEdit() {
      this.cztype = "edit";
      this.drawerTitle = "编辑";
    },
    // 查看
    handleSee(val) {
      this.cztype = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id, val.park_id);
      this.drawer = true;
    },
    handleCopy(val) {
      this.cztype = "copy";
      this.drawerTitle = "复制";
      // this.ruleForm = val
      this.getInfo(val.id, val.park_id, "copy");
      this.drawer = true;
    },
    getInfo(id, parkId, type) {
      this.parkChange(parkId);
      seeEquipmentPatrol({ id: id }).then((res) => {
        this.timeData = [];
        this.patrol_json = [];
        this.ruleForm = {
          id: res.data.info.id,
          park_id: res.data.info.park_id,
          name: res.data.info.name,
          patrol_path_id: res.data.info.patrol_path_id,
          start_date: res.data.info.start_date,
          end_date: res.data.info.end_date,
          patrol_type: res.data.info.patrol_type,
          // patrol_user_id: res.data.info.patrol_user_id,
          // patrol_role_id: res.data.info.patrol_role_id,
          status: res.data.info.status,
          pattern: res.data.info.pattern,
          system_admin_id: res.data.info.system_admin_id,
          is_share: res.data.info.is_share,
          duration_day: res.data.info.duration_day,
          is_skip_weekends: res.data.info.is_skip_weekends,
          is_jump_holiday: res.data.info.is_jump_holiday,
        };
        if (res.data.info.patrol_type == 1) {
          this.ruleForm.patrol_role_id = "";
        } else {
          this.ruleForm.patrol_user_id = "";
        }
        if (res.data.info.pattern == 1) {
          this.timeList = res.data.info.patrol_pattern_json;
        } else if (res.data.info.pattern == 2) {
          this.checkList = Object.keys(res.data.info.patrol_pattern_json);
          this.timeList = res.data.info.patrol_pattern_json;
          this.checkList = this.checkList.map(function (item, index) {
            return Number(item);
          });
          this.timeStr = res.data.info.patrol_pattern_json[this.checkList[0]];
        } else if (res.data.info.pattern == 5) {
          this.year_start_time = Object.keys(
            res.data.info.patrol_pattern_json
          )[0];
          this.timeStr =
            res.data.info.patrol_pattern_json[this.year_start_time];
        } else {
          this.dayNum = Object.keys(res.data.info.patrol_pattern_json)[0];
          this.timeStr = res.data.info.patrol_pattern_json[this.dayNum];
        }
        this.timeData.push(res.data.info.start_date);
        this.timeData.push(res.data.info.end_date);
        let arr = Object.values(res.data.info.patrol_equipment_rel);
        arr.forEach((item, index) => {
          if (item.length > 1) {
            this.getEmList(item[0].facility_id, index);
            let equipment_id = [];
            item.forEach((item1, index1) => {
              equipment_id.push(item1.facility_equipment_id);
            });
            this.patrol_json.push({
              facility_id: item[0].facility_id,
              equipment_id: equipment_id,
            });
          } else {
            this.getEmList(item[0].facility_id, index);
            let equipment_id = [];
            equipment_id.push(item[0].facility_equipment_id);
            this.patrol_json.push({
              facility_id: item[0].facility_id,
              equipment_id: equipment_id,
            });
          }
        });
        // res.data.info.patrol_equipment_rel.forEach((item,index) =>{
        //   this.patrol_json.push({ facility_id: item.facility_id, equipment_id: "" })
        // })
        if (res.data.info.is_share == 1) {
          this.ruleForm.patrol_role_id = res.data.info.patrol_role_id;
          this.ruleForm.patrol_user_id = res.data.info.patrol_user_id;
        } else {
          this.ruleForm.patrol_role_id = [];
          this.ruleForm.patrol_user_id = [];
          if (res.data.info.patrol_type == 1) {
            res.data.info.patrol_user.forEach((item, index) => {
              this.ruleForm.patrol_user_id.push(item.user_id);
            });
          } else {
            res.data.info.patrol_role.forEach((item, index) => {
              this.ruleForm.patrol_role_id.push(item.system_role_id);
            });
          }
        }
        this.getAgoUser(res.data.info.park_id);
        this.getRole(res.data.info.park_id);
        if (type == "copy") {
          delete this.ruleForm.id;
        }
      });
    },
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    openDrawer() {
      this.$refs.ruleForm.clearValidate();
    },
    // 停用任务
    disable(id, type) {
      var that = this;
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
      }
      this.$confirm("确认停用任务？")
        .then(() => {
          disableEquipmentPatrol({ id: ids.join(",") }).then((res) => {
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 启用任务
    enable(id, type) {
      var that = this;
      let ids = [];
      if (type == "single") {
        ids.push(id);
      } else {
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
      }
      this.$confirm("确认启用任务？")
        .then(() => {
          enableEquipmentPatrol({ id: ids.join(",") }).then((res) => {
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 启用任务
    delEq(id) {
      var that = this;
      this.$confirm("确认删除任务？")
        .then(() => {
          delEquipmentPatrol({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    // 获取巡检人列表
    getAgoUser(id) {
      openAgoUser({ park_id: id, type: 1, is_page: 2,is_youke:2 }).then((res) => {
        this.userList = res.data.lists;
      });
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        is_tree: 1,
        park_id: id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    // 添加每天时间
    addDomain() {
      this.timeList.push({
        start_time: "",
        end_time: "",
      });
    },
    removeDomain(index) {
      this.timeList.splice(index, 1);
    },
    // 删除
    handleDel(index) {
      this.facilityIds = [];
      var i = this.facilityIds.findIndex((item) => {
        return item == this.patrol_json[index].facility_id;
      });
      if (i != -1) {
        this.facilityIds.splice(i, 1);
      }
      // this.companyList.splice(index, 1);
      this.patrol_json.splice(index, 1);
    },
    handleAdd() {
      this.patrol_json.push({ facility_id: "", equipment_id: "" });
    },
    changeFacility(id, index) {
      this.patrol_json[index].equipment_id = "";
      this.getEmList(id, index);
      this.facilityIds = [];
      this.patrol_json.forEach((item, index) => {
        if (item.facility_id) {
          this.facilityIds.push(item.facility_id);
        }
      });
    },

    // 选择园区
    parkChange(e) {
      this.getFYList(e);
      this.getAgoUser(e);
      this.getRole(e);
    },
    getFYList(e) {
      let data = {
        page: 1,
        page_size: 5,
        is_page: 2,
        is_tree: 1,
        park_id: e,
      };
      this.facilityIds = [];
      this.patrol_json = [{ facility_id: "", equipment_id: "" }];
      getFacilityTypeList(data).then((res) => {
        this.SSoptions = res.data.lists;
      });
    },
    getEmList(id, index) {
      const data = {
        is_page: 2,
        facility_id: id,
        park_id: this.ruleForm.park_id || "",
      };
      getEquipmentList(data).then((res) => {
        this.$set(this.EmOptions, index, res.data.lists);
      });
    },
    // 设置巡检类型回调
    patrolTypeChange(e) {
      if (this.ruleForm.is_share == 1) {
        this.ruleForm.patrol_role_id = "";
        this.ruleForm.patrol_user_id = "";
      } else {
        this.ruleForm.patrol_role_id = [];
        this.ruleForm.patrol_user_id = [];
      }
    },
    addMenu() {
      this.drawerTitle = "添加巡检任务";
      this.cztype = "add";
      this.ruleForm = {
        name: "",
        park_id: "",
        start_date: "",
        end_date: "",
        status: 1,
        patrol_type: 1,
        patrol_user_id: "",
        patrol_role_id: "",
        pattern: 1,
        patrol_pattern_json: "",
        system_admin_id: this.userInfo.id,
        duration_day: "",
        is_share: 1,
        is_skip_weekends: 2,
        patrol_equipment_json: "",
        is_jump_holiday: 1,
      };
      this.timeData = [];
      this.checkList = [];
      this.patrol_json = [];
      this.timeList = [
        {
          start_time: "",
          end_time: "",
        },
      ];
      this.dayNum = 1;
      this.year_start_time = "";
      this.timeStr = {
        start_time: "",
        end_time: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.getFYList(this.userInfo.park_id);
        this.getAgoUser(this.userInfo.park_id);
        this.getRole(this.userInfo.park_id);
      }
      // this.getETList()
      this.drawer = true;
    },
    screenParkchange(e) {
      this.screen.company_id = "";
      this.screen.user_id = "";
      this.screen.allot_user_id = "";
      this.screen.dispose_user_id = "";
      this.screen.patrol_user_id = ''

      this.screen.patrol_type = ''
      this.screen.patrol_role_id = ''
    },
    chongZhi() {
      this.screen = {
        park_id: "",
        status: "",
        name: "",
        pattern: "",
        is_cross_origin: "",
        start_create_time: "",
        end_create_time: "",
        patrol_type: "",
        is_skip_weekends: "",
        is_share: "",
        keywords: "",patrol_user_id:'',
        patrol_role_id:''
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },

    handleSizeChange(val) {
      this.page_size = val;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.start_date = this.timeData[0];
          this.ruleForm.end_date = this.timeData[1];
          if (this.ruleForm.pattern == 1) {
            this.ruleForm.patrol_pattern_json = JSON.stringify(this.timeList);
          } else if (this.ruleForm.pattern == 2) {
            const list = {};
            this.checkList.forEach((item, index) => {
              this.$set(list, item, this.timeStr);
            });
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else if (this.ruleForm.pattern == 5) {
            const list = {};
            this.$set(list, this.year_start_time, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else {
            const list = {};
            this.$set(list, this.dayNum, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          }
          let equipmentList = {};
          this.patrol_json.forEach((item, index) => {
            this.$set(equipmentList, item.facility_id, item.equipment_id);
          });
          this.ruleForm.patrol_equipment_json = JSON.stringify(equipmentList);
          if (this.ruleForm.is_share == 2) {
            this.ruleForm.patrol_role_id =
              this.ruleForm.patrol_role_id.toString(",");
            this.ruleForm.patrol_user_id =
              this.ruleForm.patrol_user_id.toString(",");
          }

          this.$confirm("修改后，原任务数据将会删除，是否确认修改？", {
            type: "warning",
          })
            .then(() => {
              editEquipmentPatrol(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.start_date = this.timeData[0];
          this.ruleForm.end_date = this.timeData[1];
          if (this.ruleForm.pattern == 1) {
            this.ruleForm.patrol_pattern_json = JSON.stringify(this.timeList);
          } else if (this.ruleForm.pattern == 2) {
            const list = {};
            this.checkList.forEach((item, index) => {
              this.$set(list, item, this.timeStr);
            });
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else if (this.ruleForm.pattern == 5) {
            const list = {};
            this.$set(list, this.year_start_time, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          } else {
            const list = {};
            this.$set(list, this.dayNum, this.timeStr);
            this.ruleForm.patrol_pattern_json = JSON.stringify(list);
          }
          let equipmentList = {};
          this.patrol_json.forEach((item, index) => {
            this.$set(equipmentList, item.facility_id, item.equipment_id);
          });
          this.ruleForm.patrol_equipment_json = JSON.stringify(equipmentList);
          if (this.ruleForm.is_share == 2) {
            this.ruleForm.patrol_role_id =
              this.ruleForm.patrol_role_id.toString(",");
            this.ruleForm.patrol_user_id =
              this.ruleForm.patrol_user_id.toString(",");
          }
          this.$confirm("确认提交？")
            .then(() => {
              addEquipmentPatrol(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.drawer = false;
                  that.fetchData();
                }
              });
              // if(that.cztype == 'copy'){
              //   copyEquipmentPatrol(that.ruleForm).then((res) => {
              //   if (res.code === 200) {
              //     that.drawer = false;
              //     that.fetchData();
              //   }
              // });
              // }else{
              //   addEquipmentPatrol(that.ruleForm).then((res) => {
              //   if (res.code === 200) {
              //     that.drawer = false;
              //     that.fetchData();
              //   }
              // });
              // }
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      this.screen.page = this.page;
      this.screen.page_size = this.page_size;
      patrolEquipmentLists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.list.forEach((item, index) => {
          item.patrol_pattern_json = JSON.parse(item.patrol_pattern_json);
        });
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding: 0 20px;
  overflow: auto;
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }
}
.table-box {
  margin-top: 20px;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.searchs {
  ::v-deep .el-form-item__label {
    opacity: 0 !important;
    display: block;
  }
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
::v-deep .screen {
  padding: 0 50px;
  .el-input {
    width: 200px;
  }
  .el-form--inline .el-form-item {
    width: 23%;
  }
}
.card {
  .des-box {
    p {
      padding: 0 10px;
      &.reason {
        color: #ff3300;
      }
    }
  }
}
::v-deep .el-message {
  width: 100px !important;
  height: 10px;
}
.headbox {
  display: flex;
  justify-content: space-between;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
